import { z } from "zod";
/**
 * The SOAP sections drafted so far while the formatter writes the note. Display only: it has
 * not been parsed, grounded, or validated, and can never be inserted. Only the finalize
 * response becomes a reviewable draft.
 */
export const DemoDictationSoapPreviewSchema = z
    .object({
    subjective: z.string().max(12_000),
    objective: z.string().max(12_000),
    assessment: z.string().max(12_000),
    plan: z.string().max(12_000),
})
    .strict();
//# sourceMappingURL=dictation-preview.js.map